import React from 'react';
import styled from 'styled-components';

import { AIToolEvent, ToolDrawerOpen } from '../../tool.types';
import { SettingToolChoice } from './SettingToolChoice';
import { SettingToolEvents } from './SettingToolEvents';
import { NodeAIArgument } from '@components/Flow/Nodes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1rem;
`;

interface Props {
  openTool: ToolDrawerOpen;
  toolSettingsConfig: {
    toolChoice: string;
    setToolChoice: React.Dispatch<React.SetStateAction<string>>;
    toolEvents: AIToolEvent[];
    setToolEvents: React.Dispatch<React.SetStateAction<AIToolEvent[]>>;
    toolArguments: NodeAIArgument[];
  };
}

export const AssistantToolSettings: React.FC<Props> = ({ openTool, toolSettingsConfig }) => {
  const { tool } = openTool;

  return (
    <Container>
      <SettingToolChoice
        toolName={tool.name}
        toolChoice={toolSettingsConfig.toolChoice}
        setToolChoice={toolSettingsConfig.setToolChoice}
      />
      <SettingToolEvents
        toolEvents={toolSettingsConfig.toolEvents}
        setToolEvents={toolSettingsConfig.setToolEvents}
        toolArguments={toolSettingsConfig.toolArguments}
      />
    </Container>
  );
};
